import React from "react";
import Modal from "react-bootstrap/Modal";

const PhysicianAssociation = ({
  modalVisible,
  setModalVisible,
  clinicList,
  formData,
  handleSelectChange,
  handleAssociateClinic,
  selectedAction,
  setSelectedAction,
}) => {
  return (
    <>
      <Modal
        show={modalVisible}
        onHide={() => {setModalVisible(false); setSelectedAction("")}}
        size={"lg"}
      >
        <Modal.Header closeButton onClick={() => {setModalVisible(false); setSelectedAction("")}}>
          <Modal.Title>Update Fees</Modal.Title>{" "}
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleAssociateClinic}>
            <div className="row">

            <div className="col-xl-6">
                <div className="form-group">
                  <label className="col-form-label">
                    Consultation Fee
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Consultation Fee"
                    onChange={handleSelectChange}
                    value={formData.regularFees}
                    name="regularFees"
                    required
                  />
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                  <label className="col-form-label">
                  Follw-Up Consultation Fee
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Follw-Up Fee"
                    onChange={handleSelectChange}
                    value={formData?.followupFees}
                    name="followupFees"
                    required
                  />
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                  <label className="col-form-label">
                  Emergency Consultation Fee 
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Emergency Fee "
                    onChange={handleSelectChange}
                    value={formData?.emergencyFees}
                    name="emergencyFees"
                    required
                  />
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                  <label className="col-form-label">
                  Video Consultation Fee 
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Consultation Fee (Video)"
                    onChange={handleSelectChange}
                    value={formData?.videConsultationFees}
                    name="videConsultationFees"
                    required
                  />
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                  <label className="col-form-label">Establishment Fee</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Establishment Fee"
                    onChange={handleSelectChange}
                    value={formData?.establishmentFees}
                    name="establishmentFees"
                    required
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="submit" className="btn btn-primary">
              {selectedAction === "Update" ? "Update" : "Associate"}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {setModalVisible(false); setSelectedAction("")}}
              >
                Cancel
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PhysicianAssociation;
